/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */
import type {
  GetAgenciesSlugParams,
  GetDocumentsDocumentNumberFormatParams,
  GetDocumentsDocumentNumbersFormatParams,
  GetDocumentsFacetsFacetParams,
  GetDocumentsFormatParams,
  GetPublicInspectionDocumentsFormatParams,
  GetSuggestedSearchesParams
} from './model';

import { customInstance } from '../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Fetch a single Federal Register document
 */
export const getDocumentsDocumentNumberFormat = (
    documentNumber: string | undefined | null,
    format: 'json' | 'csv' | undefined | null,
    params?: GetDocumentsDocumentNumberFormatParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/documents/${documentNumber}.${format}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Fetch multiple Federal Register documents
 */
export const getDocumentsDocumentNumbersFormat = (
    documentNumbers: string[] | undefined | null,
    format: 'json' | 'csv' | undefined | null,
    params?: GetDocumentsDocumentNumbersFormatParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/documents/${documentNumbers}.${format}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search all Federal Register documents published since 1994.
 */
export const getDocumentsFormat = (
    format: 'json' | 'csv' | undefined | null,
    params?: GetDocumentsFormatParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/documents.${format}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Fetch counts of matching Federal Register Documents grouped by a facet
 */
export const getDocumentsFacetsFacet = (
    facet: 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly' | 'agency' | 'topic' | 'section' | 'type' | 'subtype' | undefined | null,
    params?: GetDocumentsFacetsFacetParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/documents/facets/${facet}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Fetch document table of contents based on the print edition.
 */
export const getIssuesPublicationDateFormat = (
    publicationDate: string | undefined | null,
    format: 'json' | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/issues/${publicationDate}.${format}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Fetch a single public inspection document.
 */
export const getPublicInspectionDocumentsDocumentNumberFormat = (
    documentNumber: string | undefined | null,
    format: 'json' | 'csv' | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/public-inspection-documents/${documentNumber}.${format}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Fetch multiple public inspection documents.
 */
export const getPublicInspectionDocumentsDocumentNumbersFormat = (
    documentNumbers: string[] | undefined | null,
    format: 'json' | 'csv' | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/public-inspection-documents/${documentNumbers}.${format}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Fetch all the public inspection documents that are currently on public inspection.
 */
export const getPublicInspectionDocumentsCurrentFormat = (
    format: 'json' | 'csv' | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/public-inspection-documents/current.${format}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Search all the public inspection documents that are currently on public inspection; use the document search to find documents that have been published.
 */
export const getPublicInspectionDocumentsFormat = (
    format: 'json' | 'csv' | undefined | null,
    params?: GetPublicInspectionDocumentsFormatParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/public-inspection-documents.${format}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Fetch all agency details
 */
export const getAgencies = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/agencies`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Fetch a particular agency\'s details
 */
export const getAgenciesSlug = (
    slug: string | undefined | null,
    params?: GetAgenciesSlugParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/agencies/${slug}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Fetch the available image variants and their metadata for a single image identifier
 */
export const getImagesIdentifier = (
    identifier: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/images/${identifier}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Fetch all suggested searches or limit by FederalRegister.gov section
 */
export const getSuggestedSearches = (
    params?: GetSuggestedSearchesParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/suggested_searches`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Fetch a particular suggested search
 */
export const getSuggestedSearchesSlug = (
    slug: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.federalregister.gov/suggested_searches/${slug}`, method: 'GET'
    },
      options);
    }
  
export type GetDocumentsDocumentNumberFormatResult = NonNullable<Awaited<ReturnType<typeof getDocumentsDocumentNumberFormat>>>
export type GetDocumentsDocumentNumbersFormatResult = NonNullable<Awaited<ReturnType<typeof getDocumentsDocumentNumbersFormat>>>
export type GetDocumentsFormatResult = NonNullable<Awaited<ReturnType<typeof getDocumentsFormat>>>
export type GetDocumentsFacetsFacetResult = NonNullable<Awaited<ReturnType<typeof getDocumentsFacetsFacet>>>
export type GetIssuesPublicationDateFormatResult = NonNullable<Awaited<ReturnType<typeof getIssuesPublicationDateFormat>>>
export type GetPublicInspectionDocumentsDocumentNumberFormatResult = NonNullable<Awaited<ReturnType<typeof getPublicInspectionDocumentsDocumentNumberFormat>>>
export type GetPublicInspectionDocumentsDocumentNumbersFormatResult = NonNullable<Awaited<ReturnType<typeof getPublicInspectionDocumentsDocumentNumbersFormat>>>
export type GetPublicInspectionDocumentsCurrentFormatResult = NonNullable<Awaited<ReturnType<typeof getPublicInspectionDocumentsCurrentFormat>>>
export type GetPublicInspectionDocumentsFormatResult = NonNullable<Awaited<ReturnType<typeof getPublicInspectionDocumentsFormat>>>
export type GetAgenciesResult = NonNullable<Awaited<ReturnType<typeof getAgencies>>>
export type GetAgenciesSlugResult = NonNullable<Awaited<ReturnType<typeof getAgenciesSlug>>>
export type GetImagesIdentifierResult = NonNullable<Awaited<ReturnType<typeof getImagesIdentifier>>>
export type GetSuggestedSearchesResult = NonNullable<Awaited<ReturnType<typeof getSuggestedSearches>>>
export type GetSuggestedSearchesSlugResult = NonNullable<Awaited<ReturnType<typeof getSuggestedSearchesSlug>>>
